(function () {
  'use strict';

  var lifecycleKey = typeof Symbol === 'function' && Symbol.for
    ? Symbol.for('rwady.account.header.lifecycle')
    : '__rwadyAccountHeaderLifecycle__';
  var previousLifecycle = window[lifecycleKey];
  if (previousLifecycle && typeof previousLifecycle.destroy === 'function') previousLifecycle.destroy();
  var activeController = null;

  function accountNodesWithin(scope) {
    if (!scope) return [];
    var nodes = [];
    if (scope.matches && scope.matches('[data-rwady-header-account]')) nodes.push(scope);
    if (scope.querySelectorAll) nodes = nodes.concat(Array.from(scope.querySelectorAll('[data-rwady-header-account]')));
    return nodes;
  }

  function createController(nodes) {
    if (!nodes.length || !window.RwadyAccountApi || !window.RwadyAvatar) return null;

    var apiBase = nodes[0].dataset.apiBase;
    var api = window.RwadyAccountApi.createClient({ baseUrl: apiBase });
    var disposed = false;

    function render(state) {
      if (disposed) return;
      nodes.forEach(function (node) {
        var image = node.querySelector('[data-rwady-account-avatar-image]');
        var initials = node.querySelector('[data-rwady-account-avatar-initials]');
        var guest = node.querySelector('[data-rwady-account-avatar-guest]');
        var name = node.querySelector('[data-rwady-account-first-name]');
        var isAuthenticated = Boolean(state && state.authenticated);
        var hasImage = isAuthenticated && Boolean(state.imageUrl);
        var hasInitials = isAuthenticated && !hasImage && Boolean(state.initials);

        node.classList.toggle('is-loading', Boolean(state && state.loading));
        node.classList.toggle('is-authenticated', isAuthenticated);
        node.setAttribute('aria-busy', String(Boolean(state && state.loading)));
        if (image) {
          image.hidden = !hasImage;
          if (hasImage && image.src !== state.imageUrl) image.src = state.imageUrl;
          if (!hasImage) image.removeAttribute('src');
        }
        if (initials) {
          initials.hidden = !hasInitials;
          initials.textContent = hasInitials ? state.initials : '';
        }
        if (guest) guest.hidden = hasImage || hasInitials;
        if (name) {
          name.hidden = !isAuthenticated;
          name.textContent = isAuthenticated ? state.firstName : '';
        }
        node.setAttribute('aria-label', isAuthenticated ? node.dataset.labelAccount : node.dataset.labelLogin);
      });
    }

    function onAvatarUpdated(event) {
      render(event.detail || window.RwadyAvatar.snapshot());
    }

    function onAccountLogout() {
      window.RwadyAvatar.logout();
    }

    function load() {
      render({ loading: true, authenticated: false });
      return api.session().then(function (session) {
        if (disposed) return null;
        if (!session || !session.authenticated) {
          window.RwadyAvatar.logout();
          return null;
        }
        return api.profile().then(function (payload) {
          if (disposed) return null;
          var profile = payload.customer || {};
          window.RwadyAvatar.setProfile(profile, { loading: true });
          return api.avatar().then(function (blob) {
            if (disposed) return;
            if (blob) window.RwadyAvatar.setBlob(blob, profile);
            else window.RwadyAvatar.clearImage(profile);
          }).catch(function (error) {
            if (disposed) return;
            if (error && error.status === 401) window.RwadyAvatar.logout();
            else window.RwadyAvatar.clearImage(profile);
          });
        });
      }).catch(function (error) {
        if (disposed) return;
        if (error && error.status === 401) window.RwadyAvatar.logout();
        else render({ loading: false, authenticated: false });
      });
    }

    function dispose() {
      if (disposed) return;
      disposed = true;
      document.removeEventListener('rwady:account-avatar-updated', onAvatarUpdated);
      document.removeEventListener('rwady:account-logout', onAccountLogout);
      nodes = [];
    }

    document.addEventListener('rwady:account-avatar-updated', onAvatarUpdated);
    document.addEventListener('rwady:account-logout', onAccountLogout);
    render(window.RwadyAvatar.snapshot());
    load();

    return { nodes: nodes.slice(), dispose: dispose };
  }

  function activateHeader(scope) {
    var nodes = accountNodesWithin(scope);
    if (!nodes.length) return;
    if (activeController) activeController.dispose();
    activeController = createController(nodes);
  }

  function onHeaderSectionLoad(event) {
    activateHeader(event.target);
  }

  function onHeaderSectionUnload(event) {
    if (!activeController) return;
    var target = event.target;
    var ownsNode = activeController.nodes.some(function (node) {
      return target === node || (target && target.contains && target.contains(node));
    });
    if (ownsNode) {
      activeController.dispose();
      activeController = null;
    }
  }

  function destroyHeaderLifecycle() {
    document.removeEventListener('shopify:section:load', onHeaderSectionLoad);
    document.removeEventListener('shopify:section:unload', onHeaderSectionUnload);
    window.removeEventListener('pagehide', destroyHeaderLifecycle);
    if (activeController) activeController.dispose();
    activeController = null;
    if (window[lifecycleKey] && window[lifecycleKey].destroy === destroyHeaderLifecycle) delete window[lifecycleKey];
  }

  document.addEventListener('shopify:section:load', onHeaderSectionLoad);
  document.addEventListener('shopify:section:unload', onHeaderSectionUnload);
  window.addEventListener('pagehide', destroyHeaderLifecycle);
  window[lifecycleKey] = { destroy: destroyHeaderLifecycle };
  activateHeader(document);
}());
